import { apiClient } from '../api/api';

const SHUNTING_CACHE_KEY = 'shuntingJobsCache';

/**
 * Get shunting jobs (with local cache)
 */
export async function getShuntingJobs(params: any = {}) {
    const useCache =
        !params || Object.keys(params).length === 0;

    if (useCache) {
        const cached = localStorage.getItem(SHUNTING_CACHE_KEY);

        if (cached) {
            try {
                return JSON.parse(cached);
            } catch {
                localStorage.removeItem(SHUNTING_CACHE_KEY);
            }
        }
    }

    try {
        const result = await apiClient.post<{
            message?: string;
            data: any[];
            pagination?: any;
        }>('/shunting/list', params);

        const responseData = result.data;

        // only cache default list (no filters)
        if (useCache) {
            localStorage.setItem(
                SHUNTING_CACHE_KEY,
                JSON.stringify(responseData)
            );
        }

        return responseData;
    } catch (error) {
        console.log('Unable to fetch shunting jobs:', error);
        return {
            data: [],
            pagination: {
                total: 0,
                page: 1,
                limit: 20,
                totalPages: 0
            }
        };
    }
}

/**
 * Clear cache
 */
export function clearShuntingCache() {
    localStorage.removeItem(SHUNTING_CACHE_KEY);
}

/**
 * Create new shunting job
 */
export const createShuntingJob = async (payload: any) => {
    const result = await apiClient.post<{
        message: string;
        data: any;
    }>('/shunting/create', payload);

    clearShuntingCache();

    return result;
};

/**
 * Update shunting job
 */
export const updateShuntingJob = async (payload: any) => {
    const result = await apiClient.post<{
        message: string;
        data?: any;
    }>('/shunting/update', payload);

    clearShuntingCache();

    return result;
};

/**
 * Delete shunting job
 */
export const deleteShuntingJob = async (id: number) => {
    const result = await apiClient.post<{
        message: string;
    }>('/shunting/delete', { id });

    clearShuntingCache();

    return result;
};

/**
* Approve / Revert shunting job
*/
 /**
 * Update shunting job status
 */
export const updateShuntingJobStatus = async (
    payload: {
        id: number;
        field: string;
        value: boolean;
    }
) => {

    const result = await apiClient.post<{
        message: string;
        data?: any;
    }>(
        '/shunting/update-status',
        payload
    );

    clearShuntingCache();

    return result;
};